import _typeof from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || isEmpty(time)) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * 生成随机uid
 * @returns
 */
export var guid = function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};

/**
 * 两数相乘，得到准确结果
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export var accMul = function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
};

/**
 * 两数相加
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export var accAdd = function accAdd(arg1, arg2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
};

/**
 * 两数相减
 * @param {*} arg1
 * @param {*} arg2
 * @returns
 */
export var accSubtr = function accSubtr(arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split('.')[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split('.')[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};

/**
 * 判断是否为空
 * @param {*} value
 * @returns
 */
export var isEmpty = function isEmpty(value) {
  var result = false;
  if (Object.prototype.toString.call(value) == '[object Array]') {
    result = value.length == 0 ? true : false;
  } else if (Object.prototype.toString.call(value) == '[object Object]') {
    result = Object.keys(value).length == 0 ? true : false;
  } else if (Object.prototype.toString.call(value) == '[object String]') {
    result = value.replace('/s', '').length == 0 ? true : false;
  } else if (Object.prototype.toString.call(value) == '[object Number]') {
    result = isNaN(value) ? true : false;
  } else if (Object.prototype.toString.call(value) == '[object Null]') {
    result = true;
  } else if (Object.prototype.toString.call(value) == '[object Undefined]') {
    result = true;
  } else if (Object.prototype.toString.call(value) == '[object Boolean]') {
    result = value ? false : true;
  }
  return result;
};

/**
 * 生成echart图表颜色
 * @param {*} start
 * @param {*} end
 * @param {*} steps
 * @param {*} gamma
 * @returns
 */
export var gradientColor = function gradientColor(start, end, steps, gamma) {
  if (steps == 1) {
    return [start];
  }
  var parseColor = function parseColor(hexStr) {
    return hexStr.length === 4 ? hexStr.substr(1).split('').map(function (s) {
      return 0x11 * parseInt(s, 16);
    }) : [hexStr.substr(1, 2), hexStr.substr(3, 2), hexStr.substr(5, 2)].map(function (s) {
      return parseInt(s, 16);
    });
  };

  // zero-pad 1 digit to 2
  var pad = function pad(s) {
    return s.length === 1 ? '0' + s : s;
  };
  var i,
    j,
    ms,
    me,
    output = [],
    so = [];
  gamma = gamma || 1;
  var normalize = function normalize(channel) {
    return Math.pow(channel / 255, gamma);
  };
  start = parseColor(start).map(normalize);
  end = parseColor(end).map(normalize);
  for (i = 0; i < steps; i++) {
    ms = i / (steps - 1);
    me = 1 - ms;
    for (j = 0; j < 3; j++) {
      so[j] = pad(Math.round(Math.pow(start[j] * me + end[j] * ms, 1 / gamma) * 255).toString(16));
    }
    output.push('#' + so.join(''));
  }
  return output;
};

/**
 * 处理千分位展示数据
 * @param {*} num
 * @returns
 */
export var generatingThousandthPer = function generatingThousandthPer() {
  var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  num = num + '';
  var num1 = num.split('.')[0],
    num2 = num.split('.')[1];
  var c = num1.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  return num.toString().indexOf('.') !== -1 ? c + '.' + num2 : c;
};

/**
 * 图片转换格式的方法
 * @param {*} dataurl
 * @returns
 */
export var dataURLToBlob = function dataURLToBlob(dataurl) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: mime
  });
};

/**
 *
 * @param {*} value
 * @param {*} allowNegative 是否支持校验负数
 * @returns
 */
export function isNumber(value) {
  var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // 将不是字符串转化成字符串
  var val = typeof value === 'string' ? value : String(value);
  var regExp = new RegExp("^".concat(allowNegative ? '-?' : '', "[0-9]+(\\.[0-9]+)?$"));
  var flag = true;
  if (!val.match(regExp)) {
    flag = false;
  }
  return flag;
}

/**
 * 将某个特定元素滚动至可视区域内
 * @param {*} elementPath
 */
export function scrollToError(elementPath) {
  // 	const isError = document
  // 		.getElementById('draggableCenter')
  // 		.getElementsByClassName('error')
  // 	this.$refs.phone.scrollTop = isError[0].offsetTop
  var errorElement = document.querySelector(elementPath);
  errorElement && errorElement.scrollIntoView({
    block: 'center',
    behavior: 'smooth'
  });
}
function formatDate(date) {
  var year = date.getFullYear();
  var month = ('0' + (date.getMonth() + 1)).slice(-2);
  var day = ('0' + date.getDate()).slice(-2);
  return "".concat(year, "-").concat(month, "-").concat(day);
}
/**
 * 根据传入参数获取对应今日的日期
 * @param {*} daysOffset
 * @returns
 */
export function getPastDate() {
  var daysOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var date = new Date();
  date.setDate(date.getDate() - daysOffset);
  return formatDate(date);
}
/**
 * 获取往前推 N 个自然月同一天的日期，目标月天数不足时取该月最后一天
 * @param {*} monthsOffset
 * @returns
 */
export function getPastMonth() {
  var monthsOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var now = new Date();
  var target = new Date(now.getFullYear(), now.getMonth() - monthsOffset, 1);
  var lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(now.getDate(), lastDay));
  return formatDate(target);
}